var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[this.numericValue > 0 ? 'text-green-8' : (this.numericValue === 0 ? 'text-blue-10' : 'text-red-10')]},[_vm._v(" "+_vm._s(this.value)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }